export default "__VITE_ASSET__BadjgUUI__"